var dynamics365Products = [
    {
        title: 'Business Central Apps',
        icon: 'BusinessCentral',
        description: 'Get add-ins for Business Central to connect your financials, sales, service, and operations.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-business-central'
            }
        }
    },
    {
        title: 'Commerce Apps',
        icon: 'Commerce',
        description: 'Deliver unified, personalized, and seamless buying experiences for customers and partners.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-commerce'
            }
        }
    },
    {
        title: 'Customer Service Apps',
        icon: 'CustomerService',
        description: 'Empower your customers and agents with the tools they need to ensure quick and accurate resolution.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-for-customer-services'
            }
        }
    },
    {
        title: 'Customer Voice Apps',
        icon: 'CustomerVoice',
        description: 'Enhance Customer Voice to collect, analyze, and track real-time feedback.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-customer-voice'
            }
        }
    },
    {
        title: 'Field Service Apps',
        icon: 'FieldService',
        description: 'Move from reactive to proactive to predictive service using data insights and connected experiences.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-for-field-services'
            }
        }
    },
    {
        title: 'Finance Apps',
        icon: 'FinanceOperations',
        description: 'Unify global financials and operations to empower people to make fast, informed decisions.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-for-finance-and-operations'
            }
        }
    },
    {
        title: 'Human Resources Apps',
        icon: 'HumanResources',
        description: 'Create a workplace where people and business thrive.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-human-resources'
            }
        }
    },
    {
        title: 'Marketing Apps',
        icon: 'Marketing',
        description: 'Orchestrate personalized journeys across all touchpoints to strengthen relationships and earn loyalty.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-marketing'
            }
        }
    },
    {
        title: 'Mixed Reality Apps',
        icon: 'MixedReality',
        description: 'Get add-ins to create step-by-step holographic instructions to use where the work happens.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-mixed-reality'
            }
        }
    },
    {
        title: 'Project Operations Apps',
        icon: 'ProjectOperations',
        description: 'Connect your project-centric business in one application.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-project-operations'
            }
        }
    },
    {
        title: 'Project Service Automation Apps',
        icon: 'ProjectServiceAutomation',
        description: 'Increase profitability through predictable project outcomes while increasing employee productivity.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-for-project-service-automation'
            }
        }
    },
    {
        title: 'Sales Apps',
        icon: 'Sales',
        description: 'Go beyond sales force automation to better understand customer needs, engage more effectively, and win more deals.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-for-sales'
            }
        }
    },
    {
        title: 'Supply Chain Management Apps',
        icon: 'SupplyChainManagement',
        description: 'Adapt quickly and operate sustainably with a resilient, predictive supply chain.',
        navigateOptions: {
            type: 'App',
            query: {
                product: 'dynamics-365-supply-chain-management'
            }
        }
    }
];

export { dynamics365Products };
